import { IControleDebitosResponseItem } from "../ports/ControleDebitosGateway";
import { ITabelaDebitosDataSource } from "../ports/CriarTabelaDebitos";
import ControleDebitoMapperAdapter from "./ControleDebitoMapperAdapter";
import { diContainer } from "@/di";
import { DITypes, EDateFormat } from "@/core/@types/types";
import { IF360Currency } from "@/core/plugins/currency.js/types";
import { IF360Date } from "@/core/plugins/date/F360Date";

export default class TabelaDebitosDataSourceDTO {
  static execute(
    responseData: IControleDebitosResponseItem[]
  ): ITabelaDebitosDataSource[] {
    const currency = diContainer.get<IF360Currency>(DITypes.CURRENCY);
    const date = diContainer.get<IF360Date>(DITypes.DATE);

    return responseData.map((response) => {
      const controleDebito =
        ControleDebitoMapperAdapter.toEntity(response).getProps();

      return {
        empresa: controleDebito.empresa,
        debitos: controleDebito.debitos.map((debito) => {
          const debitoProps = debito.getProps();
          const saldoDevedor = debitoProps.saldoDevedor.getProps();

          return {
            ...debitoProps,
            periodo: debitoProps.periodoApuracao || "-",
            vencimento: date.format(
              debitoProps.dataVencimento || "",
              EDateFormat.day
            ),
            declarado: currency.toMoney(debitoProps.debitoDeclarado),
            saldoDevedor: {
              juros: currency.toMoney(saldoDevedor.juros),
              multa: currency.toMoney(saldoDevedor.multa),
              principal: currency.toMoney(saldoDevedor.principal),
              total: currency.toMoney(saldoDevedor.total)
            }
          };
        })
      };
    });
  }
}
